// OpenAI（ChatGPT 広告）のコンバージョン計測ピクセルID
const OPENAI_PIXEL_ID = 'RghBEsWDYpBDizk2wgW7SA';
export const OaiqEventName = {
    ORDER_CREATED: 'order_created',
};
// OpenAI 広告のコンバージョン計測（oaiq）を担う。
// 本番のみ有効。stgのテストトラフィックが広告最適化を汚染しないよう isProduction でゲートする。
export class OaiqClient {
    constructor(config) {
        Object.defineProperty(this, "config", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.config = config;
        if (this.config.isProduction) {
            this.loadScript();
        }
    }
    loadScript() {
        const script = document.createElement('script');
        script.innerHTML = `
      window.oaiq = window.oaiq || function () {
        (window.oaiq.q = window.oaiq.q || []).push(arguments);
      };
      oaiq("init", { pixelId: "${OPENAI_PIXEL_ID}" });
    `;
        const sdk = document.createElement('script');
        sdk.async = true;
        sdk.src = 'https://bzrcdn.openai.com/sdk/oaiq.min.js';
        document.getElementsByTagName('head')[0].appendChild(script);
        document.getElementsByTagName('head')[0].appendChild(sdk);
    }
    measureOrderCreated(amount, eventId, currency = 'JPY') {
        if (!this.config.isProduction)
            return;
        window.oaiq('measure', OaiqEventName.ORDER_CREATED, { type: 'contents', amount, currency }, { event_id: eventId });
    }
}
